let createMarkup = html => ({ __html: html });

export default createMarkup;
